export class Location {
  address: string;
  latitude: number;
  longitude: number;
  name?: string;
  _id?: string;
}
